import { defineMessages } from 'react-intl';

export const cardMessages: Record<string, { id: string; defaultMessage: string }> = defineMessages({
    cardNumber: {
        id: 'card-number',
        defaultMessage: 'Vehicle ID',
    },
    nameOrCardNumber: {
        id: 'name-or-card-number',
        defaultMessage: 'Name or card number',
    },
    cardType: {
        id: 'card-type',
        defaultMessage: 'Card type',
    },
    allowedHoursStart: {
        id: 'allowed-hours-start',
        defaultMessage: 'Allowed hours start',
    },
    allowedHoursEnd: {
        id: 'allowed-hours-end',
        defaultMessage: 'Allowed hours end',
    },
    validationType: {
        id: 'validation-type',
        defaultMessage: 'Validation type',
    },
    enterDatetime: {
        id: 'entered-at',
        defaultMessage: 'Entered at',
    },
    cardTypeNormal: {
        id: 'card-type-normal',
        defaultMessage: 'Normal',
    },
    cardTypeMembership: {
        id: 'card-type-membership',
        defaultMessage: 'Membership',
    },
    cardTypeService: {
        id: 'card-type-service',
        defaultMessage: 'Service',
    },
    cardTypeVip: {
        id: 'card-type-vip',
        defaultMessage: 'VIP',
    },
    cardTypeOperator: {
        id: 'card-type-operator',
        defaultMessage: 'Operator',
    },
    cardTypePrepaid: {
        id: 'card-type-prepaid',
        defaultMessage: 'Prepaid',
    },
    cardTypePrepaidS: {
        id: 'card-type-prepaid-s',
        defaultMessage: 'Prepaid S',
    },
    vehiclesInParking: {
        id: 'vehicles-in-parking',
        defaultMessage: 'Vehicles in parking',
    },
    vehicle: {
        id: 'vehicle',
        defaultMessage: 'Vehicle',
    },
    vehicles: {
        id: 'vehicles',
        defaultMessage: 'Vehicles',
    },
    plateNumber: {
        id: 'license-plate',
        defaultMessage: 'License plate',
    },
    ownerName: {
        id: 'owner',
        defaultMessage: 'Owner',
    },

    groupName: {
        id: 'group',
        defaultMessage: 'Group',
    },
    entryPoint: {
        id: 'entry-point',
        defaultMessage: 'Entry point',
    },
    chargePlan: {
        id: 'charge-plan',
        defaultMessage: 'Charge plan',
    },
    payCard: {
        id: 'pay-card',
        defaultMessage: 'Pay',
    },
    exitCard: {
        id: 'exit-card',
        defaultMessage: 'Exit',
    },
    payCardFor: {
        id: 'pay-card-for',
        defaultMessage: 'Pay for {client}',
    },
    exitClientFromParking: {
        id: 'exit-client-from-parking',
        defaultMessage: 'Exit {client} from parking',
    },
    makeClientGuest: {
        id: 'make-client-guest',
        defaultMessage: 'Make {client} guest',
    },
    makeGuest: {
        id: 'make-guest',
        defaultMessage: 'Make guest',
    },
    changePlan: {
        id: 'change-plan',
        defaultMessage: 'Change plan',
    },
    changePlanCient: {
        id: 'change-plan-client',
        defaultMessage: 'Change charge plan',
    },
    changePlanClientDescription: {
        id: 'change-plan-client-description',
        defaultMessage: 'Change charge plan for {client}',
    },
    exitFromParking: {
        id: 'exit-from-parking',
        defaultMessage: 'Exit from parking',
    },
    parkingName: {
        id: 'parking-name',
        defaultMessage: 'Parking name',
    },
    currentStay: {
        id: 'current-stay',
        defaultMessage: 'Current stay',
    },
    dueAmount: {
        id: 'due-amount',
        defaultMessage: 'Due amount',
    },
    taxAmount: {
        id: 'tax-amount',
        defaultMessage: 'Tax amount',
    },
    totalDue: {
        id: 'total-due',
        defaultMessage: 'Total due',
    },
    vatAmount: {
        id: 'vat-amount',
        defaultMessage: 'VAT',
    },
    totalPaid: {
        id: 'total-paid',
        defaultMessage: 'Total paid',
    },
    cash: {
        id: 'cash',
        defaultMessage: 'Cash',
    },
    card: {
        id: 'card',
        defaultMessage: 'Card',
    },
    bank: {
        id: 'bank',
        defaultMessage: 'Bank',
    },
    paymentMethod: {
        id: 'payment-method',
        defaultMessage: 'Payment method',
    },
    exitPointPlaceholder: {
        id: 'exit-point-placeholder',
        defaultMessage: 'Select exit point',
    },
    paymentMethodPlaceholder: {
        id: 'payment-method-placeholder',
        defaultMessage: 'Select payment method',
    },
    guestReasonPlaceholder: {
        id: 'guest-reason-placeholder',
        defaultMessage: 'Select guest reason',
    },
    changePlanPlaceholder: {
        id: 'change-plan-placeholder',
        defaultMessage: 'Select charge plan',
    },
    openGateOnExit: {
        id: 'open-gate-on-exit',
        defaultMessage: 'Open barrier',
    },
    exitPoint: {
        id: 'exit-point',
        defaultMessage: 'Exit point',
    },
    cardPaymentSuccess: {
        id: 'card-payment-success',
        defaultMessage: 'Card payment successful',
    },
    cardPaymentSuccessDetails: {
        id: 'card-payment-success-details',
        defaultMessage: 'Card payment succesful for client {client}. The sum of {amount} was paid by {method}.',
    },
    cardExitSuccess: {
        id: 'card-exit-success',
        defaultMessage: 'Exit successful',
    },
    cardExitSucccesDetails: {
        id: 'card-exit-success-details',
        defaultMessage: 'Exit successful for client {client} at point {point}.',
    },
    makeGuestSuccess: {
        id: 'make-guest-success',
        defaultMessage: 'Guest created',
    },
    makeGuestSuccessDetails: {
        id: 'make-guest-success-details',
        defaultMessage: 'Client {client} has successfully been made guest.',
    },
    changePlanSuccess: {
        id: 'change-plan-success',
        defaultMessage: 'Charge plan changed',
    },
    changePlanSuccessDetails: {
        id: 'change-plan-success-details',
        defaultMessage: 'Charge plan for client {client} has been successfully changed to {plan}.',
    },
    ticketValidation: {
        id: 'ticket-validation',
        defaultMessage: 'Ticket validation',
    },
    ticket: {
        id: 'ticket',
        defaultMessage: 'Ticket',
    },
    parkingZone: {
        id: 'parking-zone',
        defaultMessage: 'Parking zone',
    },
    freeExit: {
        id: 'free-exit',
        defaultMessage: 'Free exit',
    },
    reason: {
        id: 'reason',
        defaultMessage: 'Reason',
    },
    otherReason: {
        id: 'other-reason',
        defaultMessage: 'Other reason',
    },
    pricingPlan: {
        id: 'pricing-plan',
        defaultMessage: 'Pricing plan',
    },
    printReceiptReminderTitle: {
        id: 'print-receipt-reminder-title',
        defaultMessage: 'Print receipt reminder',
    },
    printReceiptReminderDescription: {
        id: 'print-receipt-reminder-description',
        defaultMessage: 'Please remember to print the receipt for the transaction.',
    },
    pricingPlans: {
        id: 'pricing-plans',
        defaultMessage: 'Pricing plans',
    },
    point: {
        id: 'pricing-plans',
        defaultMessage: 'Pricing plans',
    },
    blink: {
        id: 'blink',
        defaultMessage: 'Blink',
    },
    online: {
        id: 'online',
        defaultMessage: 'Online',
    },
    withCard: {
        id: 'with-card',
        defaultMessage: 'Card',
    },
    paymentTypeBank: {
        id: 'payment-type-bank',
        defaultMessage: 'Bank',
    },
    durationStay: {
        id: 'duration-stay',
        defaultMessage: 'Duration',
    },
    exitedAt: {
        id: 'exited-at',
        defaultMessage: 'Exited at',
    },
    unknownCardType: {
        id: 'unknown-card-type',
        defaultMessage: 'Unknown',
    },
    payCardForDescription: {
        id: 'pay-card-for-description',
        defaultMessage: 'Pay the due amount for {client}',
    },
    payDueAmount: {
        id: 'pay-due-amount',
        defaultMessage: 'Pay due amount',
    },
    vehicleIsNotInParking: {
        id: 'vehicle-is-not-in-parking',
        defaultMessage: 'The vehicle is not in the parking.',
    },
    openSidePanel: {
        id: 'open-side-panel',
        defaultMessage: 'Side panel',
    },
    deleteSelectedEntries: {
        id: 'delete-selected-entries',
        defaultMessage: 'Delete selected entries',
    },
    deleteSelectedEntriesConfirmation: {
        id: 'delete-selected-entries-confirmation',
        defaultMessage:
            'Are you sure you want to delete {count, plural, one {{count, number} entry} other {{count, number} entries}}?',
    },
    cardsDeletedSuccessfully: {
        id: 'cards-deleted-successfully',
        defaultMessage: 'Deleted successfully',
    },
    cardsDeletedSuccessfullyDetails: {
        id: 'cards-deleted-successfully-details',
        defaultMessage: 'All selected vehicles were deleted successfully.',
    },
    entryFrom: {
        id: 'entry-from',
        defaultMessage: 'Entry from',
    },
    entryTo: {
        id: 'entry-to',
        defaultMessage: 'Entry to',
    },
    filterByLabel: {
        id: 'filter-by-label',
        defaultMessage: 'Filter by {value}',
    },
    other: {
        id: 'other',
        defaultMessage: 'Other',
    },
    editPlateNumber: {
        id: 'edit-plate-number',
        defaultMessage: 'Edit license plate',
    },
    editPlateNumberSubtitle: {
        id: 'edit-plate-number-subtitle',
        defaultMessage: 'Edit the license plate that has been recognized',
    },
    recognizedPlate: {
        id: 'recognized-plate',
        defaultMessage: 'Recognized plate',
    },
    modifiedPlate: {
        id: 'modified-plate',
        defaultMessage: 'Edited plate',
    },
    editPlateNumberSuccess: {
        id: 'edit-plate-number-success',
        defaultMessage: 'License plate updated',
    },
    editPlateNumberSuccessDetails: {
        id: 'edit-plate-number-success-details',
        defaultMessage: "The vehicle's license plate has been successfully updated.",
    },
});
